var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41.953 41.953",
    style: {
      enableBackground: "new 0 0 41.953 41.953"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.344,14.487h7.883c0.935,0,1.694-0.761,1.694-1.695V1.797h17.359V11.95h1.797V1.694    C34.076,0.759,33.315,0,32.382,0H14.819C14.1,0,13.26,0.417,12.825,0.993L4.207,12.412c-0.383,0.508-0.66,1.338-0.66,1.974v23.548    c0,0.935,0.76,1.694,1.694,1.694h21.104v-1.796H5.344V14.487z M13.125,3.58v9.11H6.249L13.125,3.58z",
    "data-original": "#030104",
    className: "active-path",
    "data-old_color": "#030104",
    fill: "#6295FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.434,35.298c-1.851,0-3.191,1.406-3.191,3.346c0,1.887,1.355,3.309,3.152,3.309    c1.871,0,3.23-1.391,3.23-3.309C33.625,36.704,32.283,35.298,30.434,35.298z M30.394,40.154c-0.799,0-1.356-0.621-1.356-1.511    c0-0.928,0.562-1.551,1.396-1.551c0.873,0,1.395,0.58,1.395,1.551C31.828,39.575,31.277,40.154,30.394,40.154z",
    "data-original": "#030104",
    className: "active-path",
    "data-old_color": "#030104",
    fill: "#6295FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.018,13.064c-1.845,0-3.824,0.466-5.297,1.245c-0.785,0.415-1.145,1.413-0.818,2.271l0.365,0.96    c0.321,0.846,1.379,1.232,2.213,0.799c0.814-0.426,1.873-0.68,2.822-0.68c1.863,0.029,2.809,0.852,2.809,2.443    c0,1.499-0.92,2.875-2.512,4.75c-1.988,2.384-2.892,4.938-2.615,7.367l0.037,0.506c0.06,0.761,0.804,1.334,1.73,1.334h1.479    c0.533,0,1.016-0.19,1.322-0.522c0.239-0.261,0.357-0.592,0.33-0.935l-0.037-0.467c-0.104-1.802,0.494-3.332,2.006-5.121    c2.015-2.391,3.555-4.448,3.555-7.34C38.405,16.386,36.121,13.064,31.018,13.064z M33.478,25.859    c-1.809,2.138-2.557,4.106-2.424,6.405h-1.267l-0.016-0.212c-0.223-1.957,0.539-4.048,2.199-6.041    c1.858-2.187,2.936-3.854,2.936-5.907c0-2.571-1.756-4.196-4.581-4.24h-0.009c-1.164,0-2.447,0.293-3.459,0.807l-0.299-0.773    c1.228-0.648,2.895-1.036,4.457-1.036c4.123,0,5.592,2.487,5.592,4.815C36.607,21.968,35.311,23.684,33.478,25.859z",
    "data-original": "#030104",
    className: "active-path",
    "data-old_color": "#030104",
    fill: "#6295FE"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.5593eb6683bd6d3e32f00d8e11ab3905.svg";
export { ForwardRef as ReactComponent };